import useLocalStorage from 'hooks/useLocalStorage';
import React, { createContext, useState, useEffect, useCallback } from 'react';
import { accountApiServices, invoiceApiServices } from 'utils/axios';
import { clearCookieStorage, createToken, encrypt } from 'utils/commonFunctions';

// Create Context
export const PrivateKeyContext = createContext();

const PrivateKeyProvider = ({ children }) => {
  const [privateKey, setPrivateKey] = useState(null);
  const [encryptionKey, setEncryptionKey] = useState(null);
  const [userRights, setUserRights] = useState({});
  const [userId, setUserId] = useState('');
  const [isLogin, setIsLogin] = useState(false);
  const [isLoggout, setIsLoggout] = useState(false);
  const [userNumber, setUserNumber] = useState('');
  const [isIOMDomain, setIsIOMDomain] = useState(false);
  const [, setWhiteLogoImage] = useLocalStorage('whiteLogoImage', '');
  const [, setLogoImage] = useLocalStorage('logoImage', '');
  const [, setAccountUrl] = useLocalStorage('accounts_url', '');

  // check Domain from io-market
  useEffect(() => {
    const checkCompany = 'io-market';
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    const subDomain = parts.length > 2 ? parts[parts.length - 2] : null;

    if (subDomain === checkCompany) {
      setIsIOMDomain(true);
      return;
    }
    setIsIOMDomain(false);
  }, [])

  const getConfigurations = useCallback(async () => {
    try {
      const response = await invoiceApiServices.get("/main/getMetadata");

      if (response.status === 200 && response.data.DATA) {
        const data = JSON.parse(atob(response.data.DATA));
        setPrivateKey(data.privateKey['key'] || {});
        setEncryptionKey(data.encryptionKey || "");
      }
      return null
    } catch (err) {
      console.error("Error fetching metadata:", err);
    }
  }, []);

  const getWhiteLabelConfig = useCallback(async () => {
    try {
      const hostname = window.location.hostname;
      const parts = hostname.split('.');
      const subDomain = parts.length > 2 ? parts.slice(-2).join('.') : null;
      console.log("hostname",subDomain);
      
      let dataObj = {
        "domain": subDomain,
      }
      const tokenUser = createToken(dataObj, privateKey);
      const encryptedTokenUser = encrypt(tokenUser, encryptionKey);

      const formData = new FormData();
      formData.append("encrToken", encryptedTokenUser);
      const response = await accountApiServices.post("/auth/getWhiteLabelConfig", formData);

      if (response.status === 200) {

        console.log(response.data.data.configdata);
        setWhiteLogoImage(response.data.data.configdata.company_logo);
        setLogoImage(response.data.data.configdata.company_logo);
        setAccountUrl(response.data.data.configdata?.accounts_url);
      }
      return null
    } catch (err) {
      console.error("Error fetching metadata:", err);
    }
  }, [encryptionKey, privateKey]);

  const logout = useCallback(() => {
    clearCookieStorage(encryptionKey);
    sessionStorage.clear();
    setIsLoggout(true);
  }, [encryptionKey])

  useEffect(() => {
    getConfigurations();
  }, [getConfigurations]);

  useEffect(() => {
    if (privateKey && encryptionKey && isIOMDomain) {
      getWhiteLabelConfig();
    }
  }, [privateKey, encryptionKey,isIOMDomain]);


  return <PrivateKeyContext.Provider value={{ privateKey, encryptionKey, userRights, setUserRights, userId, setUserId, logout, isLogin, setIsLogin, isLoggout, userNumber, setUserNumber, isIOMDomain }}>{children}</PrivateKeyContext.Provider>;
};

export default PrivateKeyProvider;